import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultImgService } from 'src/app/services';
import { EditedPoint } from '../../../../../../interfaces/edit-route.interface';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  // Input signals
  public indexCard = input.required<number>();
  public point = input.required<EditedPoint>();
  
  // Service injections
  private _defaultImgService = inject(DefaultImgService);

  // Methods
  /**
   * @desciption Handles image load error by setting a default image
   * @param event 
   * @returns 
   */
  public handleImgError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target) {
      const defaultImg = this.getDefaultImgFileName(this.indexCard());
      if (!defaultImg) return;
      
      target.src = defaultImg;
    }
  }
  
  /**
   * @desciption Gets the default image file name for the card
   * @param index
   * @returns 
   */
  public getDefaultImgFileName(index: number): string {
    return this._defaultImgService.getDefaultImgFileName(
      index,
      this.point().categoryList,
      this.point().type
    );
  }
}
